import {
  BtnLanguage,
  CaptionHide,
  LanguageBox,
  LanguageListBox,
  PolicyArticleTitle,
  PolicyContainer,
  PolicyHyphenList,
  PolicyList,
  PolicyMenu,
  PolicySectionTitle,
  PolicyTable,
  PolicyText,
  PolicyTitle,
  PolicyVersion,
  StyledIconDropdown,
  StyledIconGlobal,
} from "styles/PolicyCommon";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const EnPrivacy = () => {
  const [isOpen, setIsOpen] = useState(false);
  const onLanguageClick = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    document.documentElement.lang = "en";
    document.title = "40weeks later";
    return () => {
      document.documentElement.lang = "ko";
      document.title = "열달후에";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">40weeks later</h1>
      <LanguageBox isOpen={isOpen}>
        <BtnLanguage onClick={onLanguageClick}>
          <StyledIconGlobal />
          EN
          <StyledIconDropdown />
        </BtnLanguage>
        <LanguageListBox>
          <ul>
            <li className="selected">
              <em>EN</em>
            </li>
            <li>
              <Link to="/policy/ja/privacy">JP</Link>
            </li>
          </ul>
        </LanguageListBox>
      </LanguageBox>

      <PolicyTitle>Privacy Policy</PolicyTitle>

      <PolicyVersion>Effective as of 20 october 2023.</PolicyVersion>
      <PolicyText>
        When you use ‘40weeks later’, you are trusting us with intimate personal
        data. We are committed to keeping that trust, which is why our policy as
        a company is to take steps to ensure that individual user's data and
        privacy rights are protected and to provide transparency about our data
        practices.
      </PolicyText>
      <PolicyText>
        The purpose of our Privacy Policy is to explain what data we collect,
        how it is used and shared, and how you can control it.
      </PolicyText>

      <PolicySectionTitle>Introduction</PolicySectionTitle>
      <PolicyText>
        This Privacy Policy explains how Connect i Co.,Ltd. (“Connect i” or “we”
        or “us”) collects, stores, uses, transfers and shares Personal Data from
        our users (“you”) in connection with the ‘40weeks later’ mobile
        application, ‘40weeks later’ (the “App”)*, and the ‘40weeks later’
        website including any products and services related to it (the
        "Website") (all collectively, the “Services”).
      </PolicyText>
      <PolicyText>
        We reserve the right to and may change this Privacy Policy from time to
        time. If we make any material changes, we will notify you by email (sent
        to the email address provided when you register), through the App, or by
        presenting you with a new version of this Privacy Policy. If permitted
        by applicable law, your continued use of the Services after the
        effective date of an updated version of the Privacy Policy will indicate
        your acceptance of the Privacy Policy as modified. In some cases, you
        will be given a choice about whether to explicitly accept changes to the
        Privacy Policy. If you do not accept the terms of the Privacy Policy,
        please do not use the Services.
      </PolicyText>
      <PolicyText>
        Please check the Privacy Policy posted on our Website and in the App for
        the latest updates on our data privacy practices.
      </PolicyText>

      <PolicyMenu>
        <PolicyArticleTitle>Table of contents</PolicyArticleTitle>
        <ul>
          <li>
            <a href="#privacy01">1. Personal Data we collect from you</a>
          </li>
          <li>
            <a href="#privacy02">2. How we use your Personal Data</a>
          </li>
          <li>
            <a href="#privacy03">3. Your privacy rights</a>
          </li>
          <li>
            <a href="#privacy04">
              4. Third parties processing your Personal Data
            </a>
          </li>
          <li>
            <a href="#privacy05">5. Retention of your Personal Data</a>
          </li>
          <li>
            <a href="#privacy06">6. Security of your Personal Data</a>
          </li>
          <li>
            <a href="#privacy07">7. Children’s privacy</a>
          </li>
          <li>
            <a href="#privacy08">8. Communication with you</a>
          </li>
          <li>
            <a href="#privacy09">
              9. Storage and international Personal Data transfers
            </a>
          </li>
          <li>
            <a href="#privacy10">10. Data Protection Officer (DPO)</a>
          </li>
          <li>
            <a href="#privacy11">11. Contact us</a>
          </li>
        </ul>
      </PolicyMenu>

      <PolicySectionTitle id="privacy01">
        1. Personal Data we collect from you
      </PolicySectionTitle>
      <PolicyText>
        We collect Personal Data about you in a variety of ways. Sometimes we
        collect Personal Data automatically when you interact with the Services,
        and sometimes we collect the Personal Data directly from you. At times,
        we may receive Personal Data about you from other sources and third
        parties.
      </PolicyText>

      <PolicyArticleTitle>
        1) Personal Data you provide to us directly:
      </PolicyArticleTitle>
      <PolicyList>
        <li>
          <strong>A. General Information</strong>
          <br />
          When you sign up to use the Services, we may collect Personal Data
          about you such as.
          <PolicyHyphenList>
            <li>Email address</li>
            <li>Year of birth</li>
            <li>Password or passcode</li>
            <li>Nickname and photo (When using community)</li>
            <li>
              Place of residence and associated location information including
              time zone and language
            </li>
          </PolicyHyphenList>
          <PolicyText>
            Health and Well-being. When you sign up to use the Services, you may
            choose to provide Personal Data about your health and well-being
            such as
          </PolicyText>
          <PolicyTable>
            <CaptionHide>mode, Personal Data</CaptionHide>
            <colgroup>
              <col style={{ width: "30%" }} />
              <col style={{ width: "70%" }} />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">mode</th>
                <th scope="col">Personal Data</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>if you select the pregnancy mode</td>
                <td className="cell_left">
                  <PolicyHyphenList>
                    <li>
                      menstrual cycle, last menstrual day, menstrual start date,
                      menstrual end date, ovulation day
                    </li>
                    <li>
                      Ovulation test date, ovulation test photo, ovulation test
                      result
                    </li>
                    <li>
                      Pregnancy test date and time, pregnancy test photo,
                      pregnancy test result
                    </li>
                    <li>
                      Schedule History of Fertility Treatment (If Fertility
                      Treatmenty mode is selected)
                    </li>
                    <li>
                      Various symptoms related to your menstrual cycle,
                      pregnancy and health
                    </li>
                    <li>
                      Other information about your health (including sexual
                      activities), physical and mental well-being, and related
                      activities, including personal life
                    </li>
                  </PolicyHyphenList>
                </td>
              </tr>
              <tr>
                <td>if you select the pregnancy mode</td>
                <td className="cell_left">
                  <PolicyHyphenList>
                    <li>weeks and days of pregnancy</li>
                    <li>Details of your pregnancy</li>
                    <li>ultrasound images(with fetal measurements)</li>
                    <li>pre-pregnancy height, weight</li>
                    <li>weight history</li>
                  </PolicyHyphenList>
                </td>
              </tr>
              <tr>
                <td>if you select the childcare mode</td>
                <td className="cell_left">
                  <PolicyHyphenList>
                    <li>pre-pregnancy height, weight</li>
                    <li>weight in the last weeks of pregnancy</li>
                    <li>weight history</li>
                  </PolicyHyphenList>
                </td>
              </tr>
            </tbody>
          </PolicyTable>
        </li>
      </PolicyList>

      <PolicyArticleTitle>
        2) Personal Data we collect automatically:
      </PolicyArticleTitle>
      <PolicyText>
        When you access or use the Services, we may automatically collect the
        following information:
      </PolicyText>

      <PolicyList>
        <li>
          <strong>A. Device Information:</strong>
          <PolicyHyphenList>
            <li>Device model</li>
            <li>Information about the operating system and its version</li>
            <li>Unique device identifiers (e.g. IDFA)</li>
            <li>Version of your device system</li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>B. Location Information</strong>
          <PolicyHyphenList>
            <li>Language</li>
            <li>Time zone</li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>
            C. Data about your use of the Services, including, among others:
          </strong>
          <PolicyHyphenList>
            <li>Frequency of use</li>
            <li>
              Areas and features of the Services that you access, visit or use;
            </li>
            <li>Engagement with particular features.</li>
            <li>
              To collect this and other information, we may use cookies and
              other tracking technologies.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>D. Data from external sources.</strong>
          <PolicyHyphenList>
            <li>
              We may receive Personal Data about you from third parties. For
              example, we may obtain information from third parties, to enhance
              or supplement existing user information, including to customize
              and personalize your experience and for statistical purposes and
              analytics, as described below.
            </li>
          </PolicyHyphenList>
        </li>
      </PolicyList>

      <PolicyArticleTitle>
        3) Matters concerning the operation of cookies
      </PolicyArticleTitle>
      <PolicyText>
        The company uses "cookies" that store users' information and call them
        up from time to time to provide customized services to users.
      </PolicyText>
      <PolicyText>
        Cookies are small amounts of information sent by the server (HTTP) used
        to run a website to your computer browser and can also be stored on a
        user's PC computer or on a hard disk within their smartphone. After
        users access the homepage or app, they must allow cookies to log in and
        use services such as member services.
      </PolicyText>
      <PolicyText>
        The company uses cookies to find information about the ID in order to
        provide services that are appropriate and more useful to its users.
        Cookies identify the properties of the data subject's computer or
        smartphone device, but do not personally identify the data subject.
      </PolicyText>

      <PolicyList>
        <li>
          <strong>A. Purpose of using cookies</strong>
          <PolicyText>
            It is used to provide optimized information to users by identifying
            the type of visit, usage, and safe accessibility of each service and
            website of the app visited by the user
          </PolicyText>
        </li>
        <li>
          <strong>B. Set the use of Cookies</strong>
          <PolicyText>
            Users have the option of installing cookies. As a result, the user
            can either allow all cookies by setting options in a web browser, go
            through confirmation whenever they are saved, or refuse to save all
            cookies. By denying the cookie setting, you can allow all cookies,
            go through verification whenever you save them, or refuse to save
            all cookies by selecting the options in your web browser.
          </PolicyText>
          <PolicyText>
            - Example of setup (for Internet Explorer) : Tools at the top of
            your web browser &gt; Internet Options &gt; Personal Information
          </PolicyText>
          <PolicyText>
            However, if you refuse to save cookies, some services that require
            future login may be difficult to use.
          </PolicyText>
        </li>
      </PolicyList>

      <PolicySectionTitle id="privacy02">
        2. How we use your Personal Data
      </PolicySectionTitle>
      <PolicyArticleTitle>
        1) We will not collect and use your Personal Data without letting you
        know. Depending on which features of the Services you use, we will
        process your Personal Data based on one or more of the following legal
        bases:
      </PolicyArticleTitle>
      <PolicyList>
        <li>
          <strong>A. Your consent.</strong> For example, on the registration
          screen when you give us permission to process your Personal Data
        </li>
        <li>
          <strong>
            B. To fulfill our contractual obligations to you in order to provide
            the Services to you
          </strong>
        </li>
        <li>
          <strong>C. Legitimate interest.</strong> We may process your Personal
          Data in relation to our interests in providing the Services to you,
          our commercial interests, including our interest in protecting the
          security and integrity of the Services, and wider societal benefits
        </li>
        <li>
          <strong>D. Legal obligation.</strong> We may be obligated to process
          some of your Personal Data to comply with applicable laws and
          regulations
        </li>
      </PolicyList>
      <PolicyText>
        Below we describe the purposes for which we process your Personal Data
        and our lawful bases for doing so, including some basic examples
      </PolicyText>
      <PolicyTable>
        <CaptionHide>
          Purpose of processing, Legal basis for processing, example
        </CaptionHide>
        <colgroup>
          <col style={{ width: "26%" }} />
          <col style={{ width: "15%" }} />
          <col style={{ width: "60%" }} />
        </colgroup>
        <thead>
          <tr>
            <th scope="col">Purpose of processing</th>
            <th scope="col">Legal basis for processing</th>
            <th scope="col">example</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="cell_left">
              To support the existing functions of the App, including
              customization of content and materials you see when you use the
              App
            </td>
            <td>Consent</td>
            <td className="cell_left">
              We make automated decisions using your data to predict your future
              cycles or ovulation, support the health care of mothers and
              fetuses during pregnancy, and check the mother's weight care and
              the child's development during child-rearing.
              <br />
              analyze your data to provide you new features and services, and
              provide certain suggested articles or materials to read
            </td>
          </tr>
          <tr>
            <td className="cell_left">
              customization of product and service offerings and making
              recommendations to you, including third-party products and
              offerings
            </td>
            <td>Consent</td>
            <td className="cell_left">
              Customized ads and We may offer you a discount for Premium service
            </td>
          </tr>
          <tr>
            <td className="cell_left">
              to provide and deliver services you request, send you related
              information, including confirmations and reminders
            </td>
            <td>Consent</td>
            <td className="cell_left">
              Using your device data we may send you a reminder, e.g., via push
              notifications, to log your symptoms to make predictions more
              accurate and management. You can disable this anytime in your
              device settings or from within the App using the consent toggle
              screens
            </td>
          </tr>
          <tr>
            <td className="cell_left">
              for billing (invoicing), account management and other
              administrative purposes, if applicable
            </td>
            <td>Consent</td>
            <td className="cell_left">
              We may send you an email containing your invoice, if applicable
            </td>
          </tr>
          <tr>
            <td className="cell_left">
              to respond to your comments, questions and requests and to provide
              customer service
            </td>
            <td>Legitimate interest</td>
            <td className="cell_left">
              We may process your name and email to reply to your support
              request or to contact you about a specific query or question you
              have raised
            </td>
          </tr>
          <tr>
            <td className="cell_left">
              to send you technical notices, updates, security alerts and
              support and administrative messages
            </td>
            <td>Legitimate interest</td>
            <td className="cell_left">
              We may send you an email notification that contains a customer
              satisfaction survey. You can opt-out of receiving such surveys
              anytime by contacting us at after10month@connect-i.co.kr
            </td>
          </tr>
          <tr>
            <td className="cell_left">
              to monitor and analyze trends, usage and activities in connection
              with our App
            </td>
            <td>Consent</td>
            <td className="cell_left">
              We may analyze your browsing activity in the App to understand
              what you like or dislike about it in order to improve your future
              experience
            </td>
          </tr>
          <tr>
            <td className="cell_left">
              solely with respect to information that you agree to share, for
              ‘40weeks later’ promotional purposes{" "}
            </td>
            <td>Consent</td>
            <td className="cell_left">
              If you give your consent, we can post your review or comment on
              our website or SNS
            </td>
          </tr>
          <tr>
            <td className="cell_left">to verify your identity</td>
            <td>Legal obligation</td>
            <td className="cell_left">
              We may ask for age verification (e.g., an ID) if we have
              reasonable doubts regarding your age
            </td>
          </tr>
        </tbody>
      </PolicyTable>

      <PolicyArticleTitle>2) Principles of processing</PolicyArticleTitle>
      <PolicyList>
        <li>
          <strong>A. Data minimization and purpose limitation</strong>
          <br />
          We will not process Personal Data in a way that is incompatible with
          the purposes for which it has been collected or subsequently
          authorized by you or collect any Personal Data that is not needed for
          the mentioned purposes. For any new purpose of processing we will ask
          your separate consent.
        </li>
        <li>
          <strong>B. No sale of Personal Data</strong>
          <br />
          We will not sell or rent your Personal Data. We will not disclose your
          Personal Data except as otherwise described in this Privacy Policy. We
          may share your Personal Data with our service providers solely as
          described in this Privacy Policy. We will also not use information
          received through your use of the HealthKit and Google Fit framework
          for advertising or similar services, or sell it to advertising
          platforms, data brokers, or information resellers.
        </li>
      </PolicyList>

      <PolicySectionTitle id="privacy03">
        3. Your privacy rights
      </PolicySectionTitle>
      <PolicyText>
        It does not matter what country or region you come from, we are
        committed to providing you vast privacy rights in relation to your
        Personal Data.
      </PolicyText>
      <PolicyArticleTitle>1) you privacy rights</PolicyArticleTitle>
      <PolicyList>
        <li>
          <strong>A. Correction of your Personal Data</strong>
          <br />
          If you believe that your Personal Data is inaccurate, you have a right
          to contact us and ask us to correct such Personal Data.
        </li>
        <li>
          <strong>B. Restriction of Processing</strong>
          <br />
          You have a right to request that the processing of your Personal Data
          be restricted in some circumstances. For example, you have the right
          to request the restriction of your Personal Data if you contest the
          accuracy of your Personal Data and we need some time to verify its
          accuracy.
        </li>
        <li>
          <strong>
            C. Access to your Personal Data (including in portable form)
          </strong>
          <br />
          You have a right to request information about what Personal Data we
          process about you, to access all your Personal Data, and receive a
          copy of it, including in a structured and portable form (.json).
        </li>
        <li>
          <strong>D. Erasure of your Personal Data</strong>
          <br />
          You may ask us to erase your Personal Data if you withdraw your
          consent to processing, if you believe such processing is unlawful.
          Please be aware that erasing some Personal Data may affect your
          experience using certain features of the Services that rely on
          historic data.
        </li>
        <li>
          <strong>
            E. Right to object to the processing of your Personal Data
          </strong>
          <br />
          In some cases, you can object to the processing of your Personal Data,
          for example, if we process it under the legitimate interest basis, by
          contacting us at after10month@connect-i.co.kr
        </li>
      </PolicyList>
      <PolicyArticleTitle>
        2) How to exercise your privacy rights
      </PolicyArticleTitle>
      <PolicyText>
        Contact us at after10month@connect-i.co.kr to exercise your privacy
        rights
      </PolicyText>
      <PolicyText>
        We will address your request within 30 days after receipt. It may take
        us up to 90 days in some cases, for example for full erasure of your
        Personal Data stored in our backup systems. We will let you know if we
        need more time and explain the reasons for the delay.
      </PolicyText>
      <PolicyText>
        Please keep in mind that if we receive a vague request, we may contact
        you to better understand the request. We may also refuse to comply with
        a request that is manifestly unfounded and with excessive (repetitive)
        requests.
      </PolicyText>
      <PolicyText>
        We might also require you to prove your identity in some cases.
        Normally, we make sure to verify that the request is coming from the
        same email as you provided when registering. Where you have not
        registered your account, we may ask you to undergo additional
        verification measures in an effort to ensure we are appropriately
        responding to requests.
      </PolicyText>
      <PolicyText>
        Subject to applicable laws, you may have a right to lodge a complaint
        with your local data protection authority about any of our activities
        (related to your privacy rights, among others) that you think are not
        compliant with applicable law. If you have any concerns about our
        privacy practices, please let us know at after10month@connect-i.co.kr
      </PolicyText>

      <PolicySectionTitle id="privacy04">
        4. Third parties processing your Personal Data
      </PolicySectionTitle>
      <PolicyText>
        We will not share your Personal Data with third parties except as
        specified below.
      </PolicyText>

      <PolicyArticleTitle>1) Processing to make the App run</PolicyArticleTitle>
      <PolicyText>
        In some situations, we engage other companies to process your Personal
        Data on our behalf. We refer to these companies as “processors.”
      </PolicyText>
      <PolicyText>
        Processors are companies that help us run the Services, support our
        communication with you or perform other App-related activities. They may
        process certain Personal Data on our behalf to accomplish the goals
        related to the App functions and associated activities. We remain
        responsible for any acts or omissions of our processors and undertake to
        execute formal data processing agreements with them to the extent
        required by applicable law.
      </PolicyText>
      <PolicyText>
        Here is the list of our main processors upon which we rely
      </PolicyText>
      <PolicyTable>
        <CaptionHide>
          Type, processor, Processor’s privacy, Data collected, Purpose
        </CaptionHide>
        <colgroup>
          <col style={{ width: "20%" }} />
          <col style={{ width: "20%" }} />
          <col style={{ width: "20%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "30%" }} />
        </colgroup>
        <thead>
          <tr>
            <th scope="col">Type</th>
            <th scope="col">processor</th>
            <th scope="col">Processor’s privacy</th>
            <th scope="col">Data collected</th>
            <th scope="col">Purpose</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Infrastructure and security</td>
            <td>AWS (Amazon Web Services, Inc.)</td>
            <td>
              <a href="https://aws.amazon.com/ko/privacy/" target="_blank">
                AWS privacy policy
              </a>
            </td>
            <td>All Personal Data</td>
            <td className="cell_left">
              storage of all Personal Data when you use the App
            </td>
          </tr>
          <tr>
            <td>Email communications</td>
            <td>NHN Cloud (NHN Cloud, Inc. Republic of Korea)</td>
            <td>
              <a
                href="https://www.nhncloud.com/kr/terms/privacy-policy"
                target="_blank"
              >
                NHN Cloud privacy policy
              </a>
            </td>
            <td>Email address</td>
            <td className="cell_left">
              to reach you with our newsletters and notifications
            </td>
          </tr>
          <tr>
            <td>Analytical tools</td>
            <td>Google analytics (for firebase)</td>
            <td>
              <a
                href="https://policies.google.com/privacy?hl=en"
                target="_blank"
              >
                Google privacy policy
              </a>
            </td>
            <td>App usage data</td>
            <td className="cell_left">
              - to understand how you use the App, engage with particular
              features and what you like or dislike the most
              <br />- to generate statistical reports
            </td>
          </tr>
          <tr>
            <td>Processing and Analysis of Images</td>
            <td>Google cloud (vision)</td>
            <td>
              <a
                href="https://policies.google.com/privacy?hl=en"
                target="_blank"
              >
                Google privacy policy
              </a>
            </td>
            <td>Uploaded Image Data</td>
            <td className="cell_left">
              to enable the development of automated-decision making for
              providing you with predictions and app functionality
            </td>
          </tr>
          <tr>
            <td>app monitoring Platform</td>
            <td>sentry</td>
            <td>
              <a href="https://sentry.io/privacy/" target="_blank">
                Sentry privacy policy
              </a>
            </td>
            <td>App log data</td>
            <td className="cell_left">
              Application Performance Monitoring & Error Tracking
            </td>
          </tr>
        </tbody>
      </PolicyTable>
      <PolicyArticleTitle>2) Aggregated information</PolicyArticleTitle>
      <PolicyText>
        We may aggregate, anonymize or de-identify your Personal Data so that it
        cannot reasonably be used to identify you. Such data is no longer
        Personal Data. We may share such data with our partners or research
        institutions or use for statistical purposes, for example, we may share
        or use general age, demographic information and aggregate statistics
        about certain activities or symptoms from data collected to help
        identify patterns across users in articles, blog posts and scientific
        publications. Sharing this data contributes to the advancement of
        scientific research on women’s health. Our legal basis for processing
        your data for this purpose is legitimate interest.
      </PolicyText>
      <PolicyArticleTitle>3) Information posted by you</PolicyArticleTitle>
      <PolicyText>
        The App features several community areas where users with similar
        interests can share information and support one another.
      </PolicyText>
      <PolicyText>
        Any information (including Personal Data) you share in any online
        community area or online discussion is by design open to the ‘40weeks
        later’ community. You should think carefully before posting any Personal
        Data in any public forum. What you post can be seen, disclosed to, or
        collected by third parties and may be used by others in ways we cannot
        control or predict, including to contact you for unauthorized purposes.
      </PolicyText>
      <PolicyText>
        If you mistakenly post Personal Data in our community areas and would
        like it removed, you can send us an email after10month@connect-i.co.kr
      </PolicyText>
      <PolicyArticleTitle>4) Special circumstances</PolicyArticleTitle>
      <PolicyText>
        We may also share some of your Personal Data in the following special
        circumstances:
      </PolicyText>
      <PolicyHyphenList>
        <li>
          in response to subpoenas, court orders or legal processes, to the
          extent permitted and as restricted by law (including to meet national
          security or law enforcement requirements)
        </li>
        <li>
          when disclosure is required to maintain the security and integrity of
          the Services, or to protect any user’s security or the security of
          other persons, consistent with applicable laws. In such cases we may
          also delete some of your Personal Data (e.g., by resetting your
          password to avoid unauthorized access)
        </li>
        <li>
          when disclosure is directed or consented to by the user who has input
          the Personal Data
        </li>
        <li>
          in the event that we go through a business transition, such as a
          merger, divestiture, acquisition, liquidation or sale of all or a
          portion of its assets, your information will, in most instances, be
          part of the assets transferred.
        </li>
      </PolicyHyphenList>

      <PolicyText>
        Depending on the circumstance, we may rely on legitimate interest or
        legal obligation as our legal basis for the above processing activities.
      </PolicyText>

      <PolicySectionTitle id="privacy05">
        5. Retention of your Personal Data
      </PolicySectionTitle>
      <PolicyText>
        Except as set forth below, we will retain your Personal Data as long as
        needed to provide you with the Services or otherwise fulfill the
        purposes for which it was collected.
      </PolicyText>
      <PolicyList>
        <li>
          <strong>
            1) Impact of Account Deactivation(delete your account)/Requests to
            Erase Personal Data
          </strong>
          <br />
          At any time, you can deactivate your account and erase your Personal
          Data by emailing after10month@connect-i.co.kr If you choose to
          deactivate your account, ‘40weeks later’ will generally delete all
          your Personal Data and it will not be recoverable should you later
          create another account.
        </li>
        <li>
          <strong>2) Impact of App Deletion or Inactivity</strong>
          <br />
          If you choose to delete the App from your device or your account
          becomes inactive, we will retain your Personal Data for a period of 3
          years in case you decide to re-activate the Services or re-install the
          App. The App covers different periods of users’ lifecycle; therefore,
          retention of your data is needed in some cases to secure your smooth
          experience with other App functions (e.g., switching to pregnancy mode
          after cycle tracking, switching to parenting mode after childbirth).
        </li>
        <li>
          <strong>3) Limitations</strong>
          <br />
          You should be aware that, although we will anonymize or otherwise
          de-identify your data where possible, we may retain certain Personal
          Data and other information after your account has been terminated or
          deleted as necessary to comply with legal obligations, resolve
          disputes and enforce our agreements.
        </li>
      </PolicyList>

      <PolicySectionTitle id="privacy06">
        6. Security of your Personal Data
      </PolicySectionTitle>
      <PolicyList>
        <li>
          <strong>1) General security measures</strong>
          <PolicyText>
            We implement technical and organizational measures in an effort to
            protect Personal Data from loss, theft, misuse and unauthorized
            access, disclosure, alteration and destruction, taking into account
            the nature of the Personal Data that we process and risks associated
            with special categories of Personal Data we collect (information
            about health). These measures include Pseudonymization and
            tokenization of certain categories of your Personal Data.
          </PolicyText>
          <PolicyText>
            Encryption of your Personal Data in transit and in rest. Systematic
            vulnerability scanning and penetration testing. Protection of data
            integrity.
          </PolicyText>
          <PolicyText>
            Organizational and legal measures. For example, our employees have
            different levels of access to your Personal Data and only those in
            charge of data management get access to your Personal Data and only
            for limited purposes required for the operation of the Services. We
            impose strict liability on our employees for any disclosures,
            unauthorized accesses, alterations, destructions, misuses of your
            Personal Data.
          </PolicyText>
          <PolicyText>
            Conducting periodical data protection impact assessments in order to
            ensure that the Services fully adhere to the principles of ‘privacy
            by design’, ‘privacy by default’ and others. We also commit to
            undertake a privacy audit in the event of ‘40weeks later’s merger or
            takeover.
          </PolicyText>
          <PolicyText>
            Please understand that you can help keep your information secure by
            choosing and protecting your password appropriately, not sharing
            your password and preventing others from using your mobile device.
            However, no security system is perfect and, as such, we cannot
            guarantee the absolute security of the Services, or that your
            information will not be intercepted while being transmitted to us.
          </PolicyText>
        </li>
        <li>
          <strong>2) Security breaches</strong>
          <PolicyText>
            If we learn of a security systems breach, we may either post a
            notice, or attempt to notify you by email and will take reasonable
            steps to remedy the breach as specified in applicable law and this
            Privacy Policy. If we learn of a potential Personal Data breach,
            together with other actions referred to in the Privacy Policy (such
            as notifying you in certain cases), we will also undertake
            particular actions to remedy the breach as appropriate under the
            circumstances, which may include, logging you out from all the
            devices, resetting a password (sending a temporary password for you
            to apply) and performing other reasonably necessary activities and
            actions.
          </PolicyText>
          <PolicyText>
            If you want to report a security incident related to the Services
            please contact us at after10month@connect-i.co.kr
          </PolicyText>
        </li>
      </PolicyList>

      <PolicySectionTitle id="privacy07">
        7. Children’s privacy
      </PolicySectionTitle>
      <PolicyText>
        The Services are not intended for children and we do not knowingly
        collect personal information about children under 13 years old through
        the Services. If you are aware of anyone under 13 using the Services,
        please contact us at after10month@connect-i.co.kr and we will take the
        required steps to delete such information and (or) delete the child’s
        account.
      </PolicyText>

      <PolicySectionTitle id="privacy08">
        8. Communication with you
      </PolicySectionTitle>
      <PolicyText>
        We may contact you from time to time via email or through other means
        (like popups or push notifications) to communicate with you about
        products, services, offers, promotions, rewards, and events offered by
        us and others, and provide news and information that we think will be of
        interest to you.
      </PolicyText>
      <PolicyText>
        Opt-out options : You can always opt out of receiving emails by
        unsubscribing via the “Unsubscribe” link contained in the email.
        Opting-out of these emails or notifications will not end the
        transmission of important service-related emails that are necessary to
        your use of the Services. You may also opt out of receiving popups or
        push notifications by adjusting your settings in your device. If
        applicable laws prescribe so, we may ask some users to provide their
        additional consent for such communications.
      </PolicyText>

      <PolicySectionTitle id="privacy09">
        9. Storage and international Personal Data transfers
      </PolicySectionTitle>
      <PolicyText>
        ‘40weeks later’ is based in the Republic of Korea (“Korea”). Personal
        Data we collect is transferred to and processed in the U.S. (where it is
        governed by U.S. law) and to other countries (where it is governed by
        the laws of those countries). The laws of the U.S. and the laws of other
        countries may not offer the same protections as the laws of your
        jurisdiction.
      </PolicyText>

      <PolicySectionTitle id="privacy10">
        10. Data Protection Officer (DPO)
      </PolicySectionTitle>
      <PolicyText>
        To communicate with our Data Protection Officer, please email at
        after10month@connect-i.co.kr or use the contact details below.
      </PolicyText>

      <PolicySectionTitle id="privacy11">11. Contact us</PolicySectionTitle>
      <PolicyText>
        <strong>General</strong>
        <br />
        If you have any questions or concerns about your privacy you may contact
        us at:
        <br />
        <strong>Connect i Co.,Ltd,</strong> #56, B2, 176 Yanghwa-ro, Mapo-gu,
        Seoul, South Korea
        <br />
        Email : after10month@connect-i.co.kr
      </PolicyText>
    </PolicyContainer>
  );
};

export default EnPrivacy;
